module.exports = __webpack_public_path__ + "img/quanjinditu.efb63329.png";